import React from 'react'
import {
    ActionItemType,
    UserBasicInfoFragment,
} from '~graphql/generated/graphql'
import { Avatar, Flex, Icon, Center, Text } from '@chakra-ui/react'
import { getCleanEnum } from '~utils/helpers'
import {
    FaCalendarCheck,
    FaCalendarDay,
    FaCheck,
    FaEnvelope,
    FaFileCircleCheck,
    FaHouse,
    FaPaw,
    FaPen,
    FaPrescriptionBottleMedical,
    FaCamera,
    FaUser,
} from 'react-icons/fa6'
import SharedStack from '~components/shared/wrappers/shared-stack'

export const SharedTag: React.FC<{ type: ActionItemType }> = ({ type }) => {
    const label = () => {
        switch (type) {
            case ActionItemType.Reschedule:
                return 'Reschedule Request'
            case ActionItemType.Prescription:
                return 'Prescription Refill'
            case ActionItemType.PetSelfieSubmitted:
                return 'Pet Selfie'
            default:
                return getCleanEnum(type)
        }
    }

    return (
        <Text
            textTransform="uppercase"
            letterSpacing="widest"
            color="brand.600"
            fontSize="xs"
            fontWeight="semibold"
        >
            {label()}
        </Text>
    )
}

export function SharedTypeIcon({ type }: { type: ActionItemType }) {
    return (
        <Center w="32px" h="32px" bg="brand.500" rounded="full">
            <Icon
                as={getActionItemTypeIcon(type)}
                color="white"
                boxSize="16px"
            />
        </Center>
    )
}

function getActionItemTypeIcon(type: ActionItemType) {
    switch (type) {
        case ActionItemType.FormSubmitted:
            return FaFileCircleCheck
        case ActionItemType.General:
            return FaCheck
        case ActionItemType.Prescription:
            return FaPrescriptionBottleMedical
        case ActionItemType.PetSelfieSubmitted:
            return FaCamera
        case ActionItemType.MissingClient:
            return FaUser
        case ActionItemType.MissingPatient:
            return FaPaw
        case ActionItemType.Boarding:
            return FaHouse
        case ActionItemType.OfficeTask:
            return FaPen
        case ActionItemType.NewChat:
            return FaEnvelope
        case ActionItemType.PendingAppointment:
            return FaCalendarCheck
        case ActionItemType.Reschedule:
            return FaCalendarDay
        default:
            return FaCheck
    }
}

export const SharedAssignee: React.FC<{ assignee: UserBasicInfoFragment }> = ({
    assignee,
}) => (
    <SharedStack row fit spacing={1}>
        <Avatar
            size="xs"
            name={`${assignee.first_name} ${assignee.last_name}`}
            src={assignee.avatar_url || ''}
        />
        <Text
            display={{
                base: 'none',
                md: 'initial',
                xl: 'none',
                '2xl': 'initial',
            }}
            fontSize="14px"
            fontWeight="semibold"
        >{`${assignee.first_name} ${assignee.last_name}`}</Text>
    </SharedStack>
)
